import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Grid, Typography, List, ListItem, Box } from "@mui/material";

function EnterpriseData() {
    const [enterprise, setEnterprise] = useState();

    useEffect(() => {
        axios
            .get("/files/solutions/enterpriseDataWarehouse.txt")
            .then((res) => setEnterprise(res.data))
            .catch((err) => console.error(err));
    }, []);

    return (
        <Box sx={{ py: 2 }}>
            <Container maxWidth="lg">
                <Typography
                    align="center"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "#030366",
                        mb: { xs: 4, sm: 5, md: 6 },
                        mt: 7,
                        fontSize: {
                            xs: "1.8rem", // mobile
                            sm: "2.2rem", // tablet
                            md: "2.8rem", // laptop
                            lg: "3rem",  // desktop
                        },
                    }}
                >
                    Enterprise Data Warehouse
                </Typography>

                <Typography variant="body1" sx={{ mb: 2, textAlign: "justify" }}>
                    The data warehouse is the key behind a competent Business Intelligence system. This is
                    the place to store and organize your data so business users can access and query it to
                    help the company move in the right direction. This easy access to complicated data
                    enables effective business analysis and business forecasting, which in turn provides
                    great insight on various trends and supports in faster and better decision making.
                </Typography>

                <Typography variant="body1" sx={{ mb: 2, textAlign: "justify" }}>
                    VENSYX Data Solutions BI/DW offers complete suite of data warehousing solutions
                    encompassing data warehouse development, implementation, maintenance operations and
                    support. We offer full life cycle design and development activities necessary to
                    implement an end-to-end data warehouse and business intelligence solution. The service
                    delivery begins with engaging end-users in a rigorous requirements gathering process and
                    completes with the implementation of BI/DW solution.
                </Typography>

                <Typography variant="h6" sx={{ color: "#030366", fontWeight: "bold", mb: 2 }}>
                    BI Data Management offerings at VENSYX Data Solutions include:
                </Typography>

                <Grid container spacing={4} alignItems="flex-start" sx={{ mb: 4 }}>
                    <Grid item xs={12} md={6}>
                        <List>
                            <ListItem>Data Modelling</ListItem>
                            <ListItem>Data Mart Development</ListItem>
                            <ListItem>Data Integration</ListItem>
                            <ListItem>Information Delivery</ListItem>
                            <ListItem>Maintenance Operations, Support & Upgrades</ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box
                            component="img"
                            src="/images/datawarehouse.jpg"
                            alt="Enterprise Data Warehouse"
                            sx={{ width: "100%", borderRadius: 2 }}
                        />
                    </Grid>
                </Grid>

                <Typography variant="h4" sx={{ color: "#030366", fontWeight: "bold", mb: 3 }}>
                    Key Capabilities
                </Typography>

                {[
                    {
                        title: "Data Modelling",
                        content:
                            "VENSYX Data Solutions Data Modelling service provides organizations with customized, business-specific solutions and creates effective data models that meet their current and evolving needs. Our experts employ both tool-based and manual methodologies to customize existing models for enhanced business performance.",
                    },
                    {
                        title: "Data Mart Development",
                        content:
                            "VENSYX Data Solutions is a leading provider of data warehouse and data mart design and development services, VENSYX Data Solutions helps organizations across a variety of industries collate and store discrete data on a single platform, enabling effective analyses and informed business decisions.",
                    },
                    {
                        title: "Data Integration",
                        content:
                            "Build an information-enabled enterprise by speedily transforming data into a key decision driver with VENSYX Data Solutions Data Transformation service. Our engineers leverage expertise in various ETL and ETL data transformation tools and operate across a variety of sectors.",
                    },
                    {
                        title: "Information Delivery",
                        content:
                            "VENSYX Data Solutions is committed to placing data in the hands of an organization's workers in a form-factor (mobile, PDF report, Excel etc.) that ensures action is taken on the information at the right time. VENSYX Data Solutions Information Delivery service provides a single access point for aggregated information via an easy-to-use Web-based interface.",
                    },
                    {
                        title: "Maintenance Operations, Support & Upgrades",
                        content:
                            "VENSYX Data Solutions has extensive experience in delivering large-scale migration and upgrade services and has established methodologies specific to business intelligence projects. Our services are tailored to meet your needs, whether you want to upgrade to a newer version of your existing tools and applications or you are making a platform or re-engineering decision for your overall BI architecture.",
                    },
                ].map((section, index) => (
                    <Box key={index} sx={{ mb: 3 }}>
                        <Typography variant="h6" sx={{ color: "#030366", fontWeight: "500", mb: 1 }}>
                            {section.title}
                        </Typography>
                        <Typography variant="body1" sx={{ textAlign: "justify" }}>
                            {section.content}
                        </Typography>
                    </Box>
                ))}

                <Typography variant="h4" sx={{ color: "#030366", fontWeight: "bold", mb: 3 }}>
                    Business Value
                </Typography>

                <List>
                    <ListItem>
                        Easy to deploy and manage; dramatically simplifies your data warehouse and analytics
                        infrastructure
                    </ListItem>
                    <ListItem>
                        Fast time-to-value for important business intelligence and analytic initiatives that
                        impact your bottom line
                    </ListItem>
                    <ListItem>
                        Meet increasing demands for performance and capacity using cost-effective industry
                        building blocks
                    </ListItem>
                    <ListItem>
                        Protect your information with high availability, business continuity, and security
                    </ListItem>
                </List>
            </Container>
        </Box>
    );
}

export default EnterpriseData;
